import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useTheme } from '@mui/material';
import { tokens } from "../theme";
import DefaultPfp from '../img/default_pfp.jpeg'
import { getImageUrl } from '../utils/apiHelpers';

const FileUpload = ({initialImage, file, setFile, fileInputRef}) => {

    const [fileError, setFileError] = useState("");

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    let image;
    console.log(file)
    console.log(initialImage)
    if (file == undefined) {
        if (initialImage == undefined) {
            image = DefaultPfp
        } else {
            image = getImageUrl(initialImage);
        }
    } else {
        image = URL.createObjectURL(file)
    }

    return (
    <div>
        {/* Image file input field */}
        <Box display="flex" flexDirection="column">
            <img src={image} width="100px" height="100px" alt="Profilbild" />
            <Box display="flex" sx={{m: "10px 0 0 0"}}>
                <input type="file" ref={fileInputRef} onChange={(e) => {
                if (validImageTypes.includes(e.target.files[0]['type'])) {
                    setFile(e.target.files[0])
                    setFileError("");
                } else {
                    setFile(undefined)
                    setFileError("Fel typ av fil, använg .png, .jpeg eller .gif")
                }
            }}/>
            </Box>
            {
            fileError ?
            <Typography
            variant="h6"
            color={colors.redAccent[300]}
            fontWeight="medium" 
            sx={{m : "10px 0 0px 0px" }}
            >
            {fileError}
            </Typography>
            : null
            }
        </Box>
    </div>
  )
}

export default FileUpload